import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wo-dot-status',
  templateUrl: './dot-status.component.html',
  styleUrls: [ './dot-status.component.scss' ],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotStatusComponent {
  @Input({ required: true }) public type!: 'success' | 'warning' | 'error';
}
